import { c as _c } from "react/compiler-runtime";
import { DataFileInterface } from '@systemeio/file-manager';
import { BadRequest } from '@systemeio/util';
import { DomainId } from 'modules/profile/mailing-settings/types/mailing-settings-domain-interface';
import { useEffect, useState } from 'react';
import { useActOnBlur } from 'shared/hooks/use-act-on-blur';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useModal } from 'shared/hooks/use-modal';
import { useCourse } from '../../../hooks/use-course';
import { CourseEditApiInterface, CourseId } from '../../../types/course-interface';
import { useLightCourseActions } from '../../hooks/use-light-course-actions';
export const useSaveOnBlur = t0 => {
  const $ = _c(206);
  const {
    courseId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = useState();
  const {
    courseData,
    mutate
  } = useCourse(courseId);
  const {
    patchLightCourseOptions
  } = useLightCourseActions();
  const domainConfirmationModal = useModal();
  const [isCodeValid, setIsCodeValid] = useState(true);
  let t1;
  if ($[0] !== courseData) {
    t1 = () => {
      if (courseData) {
        setTempState({
          ...courseData
        });
      } else {
        setTempState(undefined);
      }
    };
    $[0] = courseData;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = courseData?.id;
  let t3;
  if ($[2] !== t2) {
    t3 = [t2];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t1, t3);
  let t4;
  if ($[4] !== courseId || $[5] !== mutate || $[6] !== patchLightCourseOptions || $[7] !== t) {
    t4 = state => ({
      action: async value => {
        if (!courseId) {
          throw new Error();
        }
        const {
          instructorName
        } = await patchLightCourseOptions(courseId, {
          instructorName: value || null
        }, "patchInstructorName");
        await mutate(data => {
          if (!data) {
            return;
          }
          return {
            ...data,
            instructorName
          };
        }, false);
      },
      onError: e => {
        if (e instanceof BadRequest) {
          state.setStatus(e.errors.fields.instructorName.toString() || t("global.error"));
        } else {
          state.setStatus(t("global.error"));
        }
      }
    });
    $[4] = courseId;
    $[5] = mutate;
    $[6] = patchLightCourseOptions;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const instructorNamePatcher = useActOnBlur(t4);
  let t5;
  if ($[9] !== courseId || $[10] !== mutate || $[11] !== patchLightCourseOptions || $[12] !== t) {
    t5 = state_0 => ({
      action: async value_0 => {
        if (!courseId) {
          throw new Error();
        }
        const {
          teacherPhoto
        } = await patchLightCourseOptions(courseId, {
          teacherPhoto: value_0
        }, "patchTeacherPhoto");
        await mutate(data_0 => {
          if (!data_0) {
            return;
          }
          return {
            ...data_0,
            teacherPhoto
          };
        }, false);
      },
      onError: e_0 => {
        if (e_0 instanceof BadRequest) {
          state_0.setStatus(e_0.errors.fields.teacherPhoto.toString() || t("global.error"));
        } else {
          state_0.setStatus(t("global.error"));
        }
      }
    });
    $[9] = courseId;
    $[10] = mutate;
    $[11] = patchLightCourseOptions;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const instructorPhotoPatcher = useActOnBlur(t5);
  let t6;
  if ($[14] !== courseId || $[15] !== mutate || $[16] !== patchLightCourseOptions || $[17] !== t) {
    t6 = state_1 => ({
      action: async logo => {
        if (!courseId) {
          throw new Error();
        }
        const newData = await patchLightCourseOptions(courseId, {
          logo
        }, "patchCourseLogo");
        await mutate(data_1 => {
          if (!data_1) {
            return;
          }
          return {
            ...data_1,
            logo: newData.logo
          };
        }, false);
      },
      onError: e_1 => {
        if (e_1 instanceof BadRequest) {
          state_1.setStatus(e_1.errors.fields.logo.toString() || t("global.error"));
        } else {
          state_1.setStatus(t("global.error"));
        }
      }
    });
    $[14] = courseId;
    $[15] = mutate;
    $[16] = patchLightCourseOptions;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const courseLogoPatcher = useActOnBlur(t6);
  let t7;
  if ($[19] !== courseId || $[20] !== mutate || $[21] !== patchLightCourseOptions || $[22] !== t) {
    t7 = state_2 => ({
      action: async image => {
        if (!courseId) {
          throw new Error();
        }
        const newData_0 = await patchLightCourseOptions(courseId, {
          image
        }, "patchCourseCover");
        await mutate(data_2 => {
          if (!data_2) {
            return;
          }
          return {
            ...data_2,
            image: newData_0.image
          };
        }, false);
      },
      onError: e_2 => {
        if (e_2 instanceof BadRequest) {
          state_2.setStatus(e_2.errors.fields.image.toString() || t("global.error"));
        } else {
          state_2.setStatus(t("global.error"));
        }
      }
    });
    $[19] = courseId;
    $[20] = mutate;
    $[21] = patchLightCourseOptions;
    $[22] = t;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  const courseCoverPatcher = useActOnBlur(t7);
  let t8;
  if ($[24] !== courseId || $[25] !== mutate || $[26] !== patchLightCourseOptions || $[27] !== t) {
    t8 = state_3 => ({
      action: async value_1 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_1 = await patchLightCourseOptions(courseId, {
          issueCertificateUponCompletion: value_1
        }, "patchIssueCertificateUponCompletion");
        await mutate(data_3 => {
          if (!data_3) {
            return;
          }
          return {
            ...data_3,
            issueCertificateUponCompletion: newData_1.issueCertificateUponCompletion
          };
        }, false);
      },
      onError: e_3 => {
        if (e_3 instanceof BadRequest) {
          state_3.setStatus(e_3.errors.fields.issueCertificateUponCompletion.toString() || t("global.error"));
        } else {
          state_3.setStatus(t("global.error"));
        }
      }
    });
    $[24] = courseId;
    $[25] = mutate;
    $[26] = patchLightCourseOptions;
    $[27] = t;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  const issueCertificateUponCompletionPatcher = useActOnBlur(t8);
  let t9;
  if ($[29] !== courseId || $[30] !== mutate || $[31] !== patchLightCourseOptions || $[32] !== t) {
    t9 = state_4 => ({
      action: async value_2 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_2 = await patchLightCourseOptions(courseId, {
          certificateLogo: value_2
        }, "patchCertificateLogo");
        await mutate(data_4 => {
          if (!data_4) {
            return;
          }
          return {
            ...data_4,
            certificateLogo: newData_2.certificateLogo
          };
        }, false);
      },
      onError: e_4 => {
        if (e_4 instanceof BadRequest) {
          state_4.setStatus(e_4.errors.fields.certificateLogo.toString() || t("global.error"));
        } else {
          state_4.setStatus(t("global.error"));
        }
      }
    });
    $[29] = courseId;
    $[30] = mutate;
    $[31] = patchLightCourseOptions;
    $[32] = t;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  const certificateLogoPatcher = useActOnBlur(t9);
  let t10;
  if ($[34] !== courseId || $[35] !== mutate || $[36] !== patchLightCourseOptions || $[37] !== t) {
    t10 = state_5 => ({
      action: async value_3 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_3 = await patchLightCourseOptions(courseId, {
          signature: value_3
        }, "patchSignature");
        await mutate(data_5 => {
          if (!data_5) {
            return;
          }
          return {
            ...data_5,
            signature: newData_3.signature
          };
        }, false);
      },
      onError: e_5 => {
        if (e_5 instanceof BadRequest) {
          state_5.setStatus(e_5.errors.fields.signature.toString() || t("global.error"));
        } else {
          state_5.setStatus(t("global.error"));
        }
      }
    });
    $[34] = courseId;
    $[35] = mutate;
    $[36] = patchLightCourseOptions;
    $[37] = t;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  const signaturePatcher = useActOnBlur(t10);
  let t11;
  if ($[39] !== courseId || $[40] !== mutate || $[41] !== patchLightCourseOptions || $[42] !== t) {
    t11 = state_6 => ({
      action: async value_4 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_4 = await patchLightCourseOptions(courseId, {
          embeddedCode: value_4 || null
        }, "patchCode");
        await mutate(data_6 => {
          if (!data_6) {
            return;
          }
          return {
            ...data_6,
            embeddedCode: newData_4.embeddedCode
          };
        }, false);
      },
      onError: e_6 => {
        if (e_6 instanceof BadRequest) {
          state_6.setStatus(e_6.errors.fields.embeddedCode.toString() || t("global.error"));
        } else {
          state_6.setStatus(t("global.error"));
        }
      }
    });
    $[39] = courseId;
    $[40] = mutate;
    $[41] = patchLightCourseOptions;
    $[42] = t;
    $[43] = t11;
  } else {
    t11 = $[43];
  }
  const codePatcher = useActOnBlur(t11, !isCodeValid);
  let t12;
  if ($[44] !== courseId || $[45] !== mutate || $[46] !== patchLightCourseOptions || $[47] !== t) {
    t12 = state_7 => ({
      action: async value_5 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_5 = await patchLightCourseOptions(courseId, {
          domainId: value_5
        }, "patchDomain");
        await mutate(data_7 => {
          if (!data_7) {
            return;
          }
          return {
            ...data_7,
            domainId: newData_5.domainId
          };
        }, false);
      },
      onError: e_7 => {
        if (e_7 instanceof BadRequest) {
          state_7.setStatus(e_7.errors.fields.domainId.toString() || t("global.error"));
        } else {
          state_7.setStatus(t("global.error"));
        }
      }
    });
    $[44] = courseId;
    $[45] = mutate;
    $[46] = patchLightCourseOptions;
    $[47] = t;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  const domainPatcher = useActOnBlur(t12);
  let t13;
  if ($[49] !== courseId || $[50] !== mutate || $[51] !== patchLightCourseOptions || $[52] !== t) {
    t13 = state_8 => ({
      action: async value_6 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_6 = await patchLightCourseOptions(courseId, {
          path: value_6
        }, "patchPath");
        await mutate(data_8 => {
          if (!data_8) {
            return;
          }
          return {
            ...data_8,
            path: newData_6.path
          };
        }, false);
      },
      onError: e_8 => {
        if (e_8 instanceof BadRequest) {
          state_8.setStatus(e_8.errors.fields.path.toString() || t("global.error"));
        } else {
          state_8.setStatus(t("global.error"));
        }
      }
    });
    $[49] = courseId;
    $[50] = mutate;
    $[51] = patchLightCourseOptions;
    $[52] = t;
    $[53] = t13;
  } else {
    t13 = $[53];
  }
  const pathPatcher = useActOnBlur(t13);
  let t14;
  if ($[54] !== courseId || $[55] !== mutate || $[56] !== patchLightCourseOptions || $[57] !== t) {
    t14 = state_9 => ({
      action: async value_7 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_7 = await patchLightCourseOptions(courseId, {
          description: value_7
        }, "patchDescription");
        await mutate(data_9 => {
          if (!data_9) {
            return;
          }
          return {
            ...data_9,
            description: newData_7.description
          };
        }, false);
      },
      onError: e_9 => {
        if (e_9 instanceof BadRequest) {
          state_9.setStatus(e_9.errors.fields.description.toString() || t("global.error"));
        } else {
          state_9.setStatus(t("global.error"));
        }
      }
    });
    $[54] = courseId;
    $[55] = mutate;
    $[56] = patchLightCourseOptions;
    $[57] = t;
    $[58] = t14;
  } else {
    t14 = $[58];
  }
  const descriptionPatcher = useActOnBlur(t14);
  let t15;
  if ($[59] !== courseId || $[60] !== mutate || $[61] !== patchLightCourseOptions || $[62] !== t) {
    t15 = state_10 => ({
      action: async value_8 => {
        if (!courseId) {
          throw new Error();
        }
        const newData_8 = await patchLightCourseOptions(courseId, {
          name: value_8
        }, "patchName");
        await mutate(data_10 => {
          if (!data_10) {
            return;
          }
          return {
            ...data_10,
            name: newData_8.name
          };
        }, false);
      },
      onError: e_10 => {
        if (e_10 instanceof BadRequest) {
          state_10.setStatus(e_10.errors.fields.name.toString() || t("global.error"));
        } else {
          state_10.setStatus(t("global.error"));
        }
      }
    });
    $[59] = courseId;
    $[60] = mutate;
    $[61] = patchLightCourseOptions;
    $[62] = t;
    $[63] = t15;
  } else {
    t15 = $[63];
  }
  const namePatcher = useActOnBlur(t15);
  let errors;
  let handleBlur;
  let handleCertificateLogoChange;
  let handleCourseCoverChange;
  let handleCourseLogoChange;
  let handleDomainChange;
  let handleDomainChangeConfirm;
  let handleIssueCertificateUponCompletionChange;
  let handleSignatureChange;
  let handleTeacherPhotoChange;
  let isSuccess;
  let statusIcon;
  if ($[64] !== certificateLogoPatcher.error || $[65] !== certificateLogoPatcher.handleBlur || $[66] !== certificateLogoPatcher.isSuccess || $[67] !== certificateLogoPatcher.statusIcon || $[68] !== codePatcher.error || $[69] !== codePatcher.handleBlur || $[70] !== codePatcher.isSuccess || $[71] !== codePatcher.statusIcon || $[72] !== courseCoverPatcher.error || $[73] !== courseCoverPatcher.handleBlur || $[74] !== courseCoverPatcher.isSuccess || $[75] !== courseCoverPatcher.statusIcon || $[76] !== courseLogoPatcher.error || $[77] !== courseLogoPatcher.handleBlur || $[78] !== courseLogoPatcher.isSuccess || $[79] !== courseLogoPatcher.statusIcon || $[80] !== descriptionPatcher.error || $[81] !== descriptionPatcher.handleBlur || $[82] !== descriptionPatcher.isSuccess || $[83] !== descriptionPatcher.statusIcon || $[84] !== domainConfirmationModal || $[85] !== domainPatcher.error || $[86] !== domainPatcher.handleBlur || $[87] !== domainPatcher.isSuccess || $[88] !== domainPatcher.statusIcon || $[89] !== instructorNamePatcher.error || $[90] !== instructorNamePatcher.handleBlur || $[91] !== instructorNamePatcher.isSuccess || $[92] !== instructorNamePatcher.statusIcon || $[93] !== instructorPhotoPatcher.error || $[94] !== instructorPhotoPatcher.handleBlur || $[95] !== instructorPhotoPatcher.isSuccess || $[96] !== instructorPhotoPatcher.statusIcon || $[97] !== issueCertificateUponCompletionPatcher.error || $[98] !== issueCertificateUponCompletionPatcher.handleBlur || $[99] !== issueCertificateUponCompletionPatcher.isSuccess || $[100] !== issueCertificateUponCompletionPatcher.statusIcon || $[101] !== namePatcher.error || $[102] !== namePatcher.handleBlur || $[103] !== namePatcher.isSuccess || $[104] !== namePatcher.statusIcon || $[105] !== pathPatcher.error || $[106] !== pathPatcher.handleBlur || $[107] !== pathPatcher.isSuccess || $[108] !== pathPatcher.statusIcon || $[109] !== signaturePatcher.error || $[110] !== signaturePatcher.handleBlur || $[111] !== signaturePatcher.isSuccess || $[112] !== signaturePatcher.statusIcon) {
    handleTeacherPhotoChange = async file => {
      handleBlur.teacherPhoto(file ? file.id : null);
    };
    handleCourseLogoChange = async file_0 => {
      handleBlur.logo(file_0 ? file_0.id : null);
    };
    handleCourseCoverChange = async file_1 => {
      handleBlur.image(file_1 ? file_1.id : null);
    };
    handleCertificateLogoChange = async file_2 => {
      handleBlur.certificateLogo(file_2 ? file_2.id : null);
    };
    handleSignatureChange = async file_3 => {
      handleBlur.signature(file_3 ? file_3.id : null);
    };
    let t16;
    if ($[125] !== domainConfirmationModal) {
      t16 = async domainId => {
        domainConfirmationModal.open(domainId);
      };
      $[125] = domainConfirmationModal;
      $[126] = t16;
    } else {
      t16 = $[126];
    }
    handleDomainChange = t16;
    handleDomainChangeConfirm = async () => {
      if (domainConfirmationModal.data) {
        await handleBlur.domainId(domainConfirmationModal.data);
      }
    };
    handleIssueCertificateUponCompletionChange = async value_9 => {
      handleBlur.issueCertificateUponCompletion(value_9);
    };
    let t17;
    if ($[127] !== certificateLogoPatcher.error || $[128] !== codePatcher.error || $[129] !== courseCoverPatcher.error || $[130] !== courseLogoPatcher.error || $[131] !== descriptionPatcher.error || $[132] !== domainPatcher.error || $[133] !== instructorNamePatcher.error || $[134] !== instructorPhotoPatcher.error || $[135] !== issueCertificateUponCompletionPatcher.error || $[136] !== namePatcher.error || $[137] !== pathPatcher.error || $[138] !== signaturePatcher.error) {
      t17 = {
        instructorName: instructorNamePatcher.error,
        name: namePatcher.error,
        description: descriptionPatcher.error,
        embeddedCode: codePatcher.error,
        path: pathPatcher.error,
        teacherPhoto: instructorPhotoPatcher.error,
        domainId: domainPatcher.error,
        logo: courseLogoPatcher.error,
        image: courseCoverPatcher.error,
        issueCertificateUponCompletion: issueCertificateUponCompletionPatcher.error,
        certificateLogo: certificateLogoPatcher.error,
        signature: signaturePatcher.error
      };
      $[127] = certificateLogoPatcher.error;
      $[128] = codePatcher.error;
      $[129] = courseCoverPatcher.error;
      $[130] = courseLogoPatcher.error;
      $[131] = descriptionPatcher.error;
      $[132] = domainPatcher.error;
      $[133] = instructorNamePatcher.error;
      $[134] = instructorPhotoPatcher.error;
      $[135] = issueCertificateUponCompletionPatcher.error;
      $[136] = namePatcher.error;
      $[137] = pathPatcher.error;
      $[138] = signaturePatcher.error;
      $[139] = t17;
    } else {
      t17 = $[139];
    }
    errors = t17;
    let t18;
    if ($[140] !== certificateLogoPatcher.isSuccess || $[141] !== codePatcher.isSuccess || $[142] !== courseCoverPatcher.isSuccess || $[143] !== courseLogoPatcher.isSuccess || $[144] !== descriptionPatcher.isSuccess || $[145] !== domainPatcher.isSuccess || $[146] !== instructorNamePatcher.isSuccess || $[147] !== instructorPhotoPatcher.isSuccess || $[148] !== issueCertificateUponCompletionPatcher.isSuccess || $[149] !== namePatcher.isSuccess || $[150] !== pathPatcher.isSuccess || $[151] !== signaturePatcher.isSuccess) {
      t18 = {
        instructorName: instructorNamePatcher.isSuccess,
        name: namePatcher.isSuccess,
        description: descriptionPatcher.isSuccess,
        embeddedCode: codePatcher.isSuccess,
        path: pathPatcher.isSuccess,
        teacherPhoto: instructorPhotoPatcher.isSuccess,
        domainId: domainPatcher.isSuccess,
        logo: courseLogoPatcher.isSuccess,
        image: courseCoverPatcher.isSuccess,
        issueCertificateUponCompletion: issueCertificateUponCompletionPatcher.isSuccess,
        certificateLogo: certificateLogoPatcher.isSuccess,
        signature: signaturePatcher.isSuccess
      };
      $[140] = certificateLogoPatcher.isSuccess;
      $[141] = codePatcher.isSuccess;
      $[142] = courseCoverPatcher.isSuccess;
      $[143] = courseLogoPatcher.isSuccess;
      $[144] = descriptionPatcher.isSuccess;
      $[145] = domainPatcher.isSuccess;
      $[146] = instructorNamePatcher.isSuccess;
      $[147] = instructorPhotoPatcher.isSuccess;
      $[148] = issueCertificateUponCompletionPatcher.isSuccess;
      $[149] = namePatcher.isSuccess;
      $[150] = pathPatcher.isSuccess;
      $[151] = signaturePatcher.isSuccess;
      $[152] = t18;
    } else {
      t18 = $[152];
    }
    isSuccess = t18;
    let t19;
    if ($[153] !== certificateLogoPatcher.statusIcon || $[154] !== codePatcher.statusIcon || $[155] !== courseCoverPatcher.statusIcon || $[156] !== courseLogoPatcher.statusIcon || $[157] !== descriptionPatcher.statusIcon || $[158] !== domainPatcher.statusIcon || $[159] !== instructorNamePatcher.statusIcon || $[160] !== instructorPhotoPatcher.statusIcon || $[161] !== issueCertificateUponCompletionPatcher.statusIcon || $[162] !== namePatcher.statusIcon || $[163] !== pathPatcher.statusIcon || $[164] !== signaturePatcher.statusIcon) {
      t19 = {
        instructorName: instructorNamePatcher.statusIcon,
        name: namePatcher.statusIcon,
        description: descriptionPatcher.statusIcon,
        embeddedCode: codePatcher.statusIcon,
        path: pathPatcher.statusIcon,
        teacherPhoto: instructorPhotoPatcher.statusIcon,
        domainId: domainPatcher.statusIcon,
        logo: courseLogoPatcher.statusIcon,
        image: courseCoverPatcher.statusIcon,
        issueCertificateUponCompletion: issueCertificateUponCompletionPatcher.statusIcon,
        certificateLogo: certificateLogoPatcher.statusIcon,
        signature: signaturePatcher.statusIcon
      };
      $[153] = certificateLogoPatcher.statusIcon;
      $[154] = codePatcher.statusIcon;
      $[155] = courseCoverPatcher.statusIcon;
      $[156] = courseLogoPatcher.statusIcon;
      $[157] = descriptionPatcher.statusIcon;
      $[158] = domainPatcher.statusIcon;
      $[159] = instructorNamePatcher.statusIcon;
      $[160] = instructorPhotoPatcher.statusIcon;
      $[161] = issueCertificateUponCompletionPatcher.statusIcon;
      $[162] = namePatcher.statusIcon;
      $[163] = pathPatcher.statusIcon;
      $[164] = signaturePatcher.statusIcon;
      $[165] = t19;
    } else {
      t19 = $[165];
    }
    statusIcon = t19;
    handleBlur = {
      instructorName: instructorNamePatcher.handleBlur,
      name: namePatcher.handleBlur,
      description: descriptionPatcher.handleBlur,
      embeddedCode: codePatcher.handleBlur,
      path: pathPatcher.handleBlur,
      teacherPhoto: instructorPhotoPatcher.handleBlur,
      domainId: domainPatcher.handleBlur,
      logo: courseLogoPatcher.handleBlur,
      image: courseCoverPatcher.handleBlur,
      issueCertificateUponCompletion: issueCertificateUponCompletionPatcher.handleBlur,
      certificateLogo: certificateLogoPatcher.handleBlur,
      signature: signaturePatcher.handleBlur
    };
    $[64] = certificateLogoPatcher.error;
    $[65] = certificateLogoPatcher.handleBlur;
    $[66] = certificateLogoPatcher.isSuccess;
    $[67] = certificateLogoPatcher.statusIcon;
    $[68] = codePatcher.error;
    $[69] = codePatcher.handleBlur;
    $[70] = codePatcher.isSuccess;
    $[71] = codePatcher.statusIcon;
    $[72] = courseCoverPatcher.error;
    $[73] = courseCoverPatcher.handleBlur;
    $[74] = courseCoverPatcher.isSuccess;
    $[75] = courseCoverPatcher.statusIcon;
    $[76] = courseLogoPatcher.error;
    $[77] = courseLogoPatcher.handleBlur;
    $[78] = courseLogoPatcher.isSuccess;
    $[79] = courseLogoPatcher.statusIcon;
    $[80] = descriptionPatcher.error;
    $[81] = descriptionPatcher.handleBlur;
    $[82] = descriptionPatcher.isSuccess;
    $[83] = descriptionPatcher.statusIcon;
    $[84] = domainConfirmationModal;
    $[85] = domainPatcher.error;
    $[86] = domainPatcher.handleBlur;
    $[87] = domainPatcher.isSuccess;
    $[88] = domainPatcher.statusIcon;
    $[89] = instructorNamePatcher.error;
    $[90] = instructorNamePatcher.handleBlur;
    $[91] = instructorNamePatcher.isSuccess;
    $[92] = instructorNamePatcher.statusIcon;
    $[93] = instructorPhotoPatcher.error;
    $[94] = instructorPhotoPatcher.handleBlur;
    $[95] = instructorPhotoPatcher.isSuccess;
    $[96] = instructorPhotoPatcher.statusIcon;
    $[97] = issueCertificateUponCompletionPatcher.error;
    $[98] = issueCertificateUponCompletionPatcher.handleBlur;
    $[99] = issueCertificateUponCompletionPatcher.isSuccess;
    $[100] = issueCertificateUponCompletionPatcher.statusIcon;
    $[101] = namePatcher.error;
    $[102] = namePatcher.handleBlur;
    $[103] = namePatcher.isSuccess;
    $[104] = namePatcher.statusIcon;
    $[105] = pathPatcher.error;
    $[106] = pathPatcher.handleBlur;
    $[107] = pathPatcher.isSuccess;
    $[108] = pathPatcher.statusIcon;
    $[109] = signaturePatcher.error;
    $[110] = signaturePatcher.handleBlur;
    $[111] = signaturePatcher.isSuccess;
    $[112] = signaturePatcher.statusIcon;
    $[113] = errors;
    $[114] = handleBlur;
    $[115] = handleCertificateLogoChange;
    $[116] = handleCourseCoverChange;
    $[117] = handleCourseLogoChange;
    $[118] = handleDomainChange;
    $[119] = handleDomainChangeConfirm;
    $[120] = handleIssueCertificateUponCompletionChange;
    $[121] = handleSignatureChange;
    $[122] = handleTeacherPhotoChange;
    $[123] = isSuccess;
    $[124] = statusIcon;
  } else {
    errors = $[113];
    handleBlur = $[114];
    handleCertificateLogoChange = $[115];
    handleCourseCoverChange = $[116];
    handleCourseLogoChange = $[117];
    handleDomainChange = $[118];
    handleDomainChangeConfirm = $[119];
    handleIssueCertificateUponCompletionChange = $[120];
    handleSignatureChange = $[121];
    handleTeacherPhotoChange = $[122];
    isSuccess = $[123];
    statusIcon = $[124];
  }
  let t16;
  if ($[166] !== certificateLogoPatcher.isInProgress || $[167] !== codePatcher.isInProgress || $[168] !== courseCoverPatcher.isInProgress || $[169] !== courseLogoPatcher.isInProgress || $[170] !== descriptionPatcher.isInProgress || $[171] !== domainPatcher.isInProgress || $[172] !== instructorNamePatcher.isInProgress || $[173] !== instructorPhotoPatcher.isInProgress || $[174] !== issueCertificateUponCompletionPatcher.isInProgress || $[175] !== namePatcher.isInProgress || $[176] !== pathPatcher.isInProgress || $[177] !== signaturePatcher.isInProgress) {
    t16 = {
      instructorName: instructorNamePatcher.isInProgress,
      name: namePatcher.isInProgress,
      description: descriptionPatcher.isInProgress,
      embeddedCode: codePatcher.isInProgress,
      path: pathPatcher.isInProgress,
      teacherPhoto: instructorPhotoPatcher.isInProgress,
      domainId: domainPatcher.isInProgress,
      logo: courseLogoPatcher.isInProgress,
      image: courseCoverPatcher.isInProgress,
      issueCertificateUponCompletion: issueCertificateUponCompletionPatcher.isInProgress,
      certificateLogo: certificateLogoPatcher.isInProgress,
      signature: signaturePatcher.isInProgress
    };
    $[166] = certificateLogoPatcher.isInProgress;
    $[167] = codePatcher.isInProgress;
    $[168] = courseCoverPatcher.isInProgress;
    $[169] = courseLogoPatcher.isInProgress;
    $[170] = descriptionPatcher.isInProgress;
    $[171] = domainPatcher.isInProgress;
    $[172] = instructorNamePatcher.isInProgress;
    $[173] = instructorPhotoPatcher.isInProgress;
    $[174] = issueCertificateUponCompletionPatcher.isInProgress;
    $[175] = namePatcher.isInProgress;
    $[176] = pathPatcher.isInProgress;
    $[177] = signaturePatcher.isInProgress;
    $[178] = t16;
  } else {
    t16 = $[178];
  }
  const isInProgress = t16;
  const t17 = courseData?.teacherPhoto;
  const t18 = courseData?.domainId;
  const t19 = courseData?.logo;
  const t20 = courseData?.image;
  const t21 = courseData?.issueCertificateUponCompletion;
  const t22 = courseData?.certificateLogo;
  const t23 = courseData?.signature;
  let t24;
  if ($[179] !== t17 || $[180] !== t18 || $[181] !== t19 || $[182] !== t20 || $[183] !== t21 || $[184] !== t22 || $[185] !== t23 || $[186] !== tempState) {
    t24 = {
      ...tempState,
      teacherPhoto: t17,
      domainId: t18,
      logo: t19,
      image: t20,
      issueCertificateUponCompletion: t21,
      certificateLogo: t22,
      signature: t23
    };
    $[179] = t17;
    $[180] = t18;
    $[181] = t19;
    $[182] = t20;
    $[183] = t21;
    $[184] = t22;
    $[185] = t23;
    $[186] = tempState;
    $[187] = t24;
  } else {
    t24 = $[187];
  }
  let t25;
  if ($[188] !== courseData || $[189] !== domainConfirmationModal || $[190] !== errors || $[191] !== handleBlur || $[192] !== handleCertificateLogoChange || $[193] !== handleCourseCoverChange || $[194] !== handleCourseLogoChange || $[195] !== handleDomainChange || $[196] !== handleDomainChangeConfirm || $[197] !== handleIssueCertificateUponCompletionChange || $[198] !== handleSignatureChange || $[199] !== handleTeacherPhotoChange || $[200] !== isCodeValid || $[201] !== isInProgress || $[202] !== isSuccess || $[203] !== statusIcon || $[204] !== t24) {
    t25 = {
      tempState: t24,
      setTempState,
      courseData,
      errors,
      isSuccess,
      statusIcon,
      handleBlur,
      isInProgress,
      handleTeacherPhotoChange,
      handleCourseLogoChange,
      handleCourseCoverChange,
      handleCertificateLogoChange,
      handleSignatureChange,
      handleIssueCertificateUponCompletionChange,
      domainConfirmationModal,
      handleDomainChange,
      handleDomainChangeConfirm,
      isCodeValid,
      setIsCodeValid
    };
    $[188] = courseData;
    $[189] = domainConfirmationModal;
    $[190] = errors;
    $[191] = handleBlur;
    $[192] = handleCertificateLogoChange;
    $[193] = handleCourseCoverChange;
    $[194] = handleCourseLogoChange;
    $[195] = handleDomainChange;
    $[196] = handleDomainChangeConfirm;
    $[197] = handleIssueCertificateUponCompletionChange;
    $[198] = handleSignatureChange;
    $[199] = handleTeacherPhotoChange;
    $[200] = isCodeValid;
    $[201] = isInProgress;
    $[202] = isSuccess;
    $[203] = statusIcon;
    $[204] = t24;
    $[205] = t25;
  } else {
    t25 = $[205];
  }
  return t25;
};